module.exports = __webpack_public_path__ + "img/02.5ed4f517.png";